//import HomeIcon from 'assets/icons/Home-icon-orange.svg?react';
import AgendaIcon from 'assets/icons/agenda-menu-icon.svg?react';
import DashIcon from 'assets/icons/dash-menu-icon.svg?react';
import GeoIcon from 'assets/icons/geo-menu-icon.svg?react';
import OccurIcon from 'assets/icons/occur-menu-icon.svg?react';
import ActvIcon from 'assets/icons/actv-menu-icon.svg?react';
import ReportsIcon from 'assets/icons/report-menu-icon.svg?react';
import MaterialsIcon from 'assets/icons/materials-menu-icon.svg?react';
import DocIcon from 'assets/icons/doc-menu-icon.svg?react';
import RegIcon from 'assets/icons/registry-menu-icon.svg?react';
import ConfigIcon from 'assets/icons/config-menu-icon.svg?react';

export const iconObj = Object.fromEntries([
  //['Home', <HomeIcon />],
  ['Dashboard', <DashIcon />],
  ['Agenda', <AgendaIcon />],
  ['Ocorrências', <OccurIcon />],
  ['Atividades', <ActvIcon />],
  ['Relatórios', <ReportsIcon />],
  ['Materiais', <MaterialsIcon />],
  ['Cadastros', <RegIcon />],
  ['Documentos', <DocIcon />],
  ['Configurações', <ConfigIcon />],
  ['Geolocalização', <GeoIcon />],
]);
